import { Query } from '@cubejs-client/core';
import { CardGraphBase } from '../CardGraphBase';

export default class ForfeitsCard extends CardGraphBase {
  graphName() { return ''; }

  graphSubtitle() {
    return 'Number of forfeits';
  }

  query(): Query {
    return {
      measures: [
        'FctGeneral.numberOfForfeits',
      ],
      timeDimensions: [
        {
          dimension: 'FctGeneral.dateDay',
          dateRange: this.props?.timePeriod,
        },
      ],
      order: {},
      filters: [
        {
          dimension: 'FctGeneral.organisationId',
          operator: 'equals',
          values: [
            this.props.organisationId,
          ],
        },
        // {
        //   dimension: 'FctGeneral.competitionId',
        //   operator: 'equals',
        //   values: [
        //     this.props.competitionId,
        //   ],
        // },
      ],
    };
  }
}
